export const EMAIL_TEMPLATES = [
  {
    id: "saluti",
    label: "Saluti · primo contatto",
    subject: "Una proposta per {azienda}",
    message: "Buongiorno {nome},\n\nsono del team Aurora-ADV. Ho avuto modo di conoscere {azienda} e il lavoro che svolgete a {citta}: complimenti.\n\nAiutiamo attività come la vostra ad acquisire nuovi clienti in modo misurabile, con campagne mirate su Google, Meta e WhatsApp.\n\nIn allegato trovate una breve presentazione. Sarei lieto di fissare una chiamata di 15 minuti nei prossimi giorni.\n\nCordiali saluti,\nTeam Aurora-ADV",
  },
  {
    id: "followup",
    label: "Follow-up",
    subject: "Re: la nostra proposta per {azienda}",
    message: "Buongiorno {nome},\n\nle scrivo per un breve follow-up sulla presentazione inviata nei giorni scorsi a {azienda}.\n\nHa avuto modo di darle un'occhiata? Se utile, posso prepararle un'analisi gratuita del potenziale di nuovi clienti nella zona di {citta}.\n\nResto a disposizione per qualsiasi domanda.\n\nCordiali saluti,\nTeam Aurora-ADV",
  },
  {
    id: "promo",
    label: "Promo · offerta riservata",
    subject: "Offerta riservata a {azienda} · {citta}",
    message: "Buongiorno {nome},\n\nper un numero limitato di attività a {citta} abbiamo riservato un'offerta di lancio: la prima campagna di acquisizione clienti con setup incluso e report settimanale dei risultati.\n\nL'offerta è valida fino a fine mese. Trova i dettagli nella presentazione allegata.\n\nRisponda pure a questa email per attivarla per {azienda}.\n\nCordiali saluti,\nTeam Aurora-ADV",
  },
];

export const fillPlaceholders = (text, lead) =>
  (text || "")
    .replaceAll("{nome}", lead?.contact_first_name || lead?.company_name || "")
    .replaceAll("{citta}", lead?.city || "")
    .replaceAll("{azienda}", lead?.company_name || "");
